module.exports = __webpack_public_path__ + "static/img/-v-3.17971fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-v-3.png
// module id = 2WrO
// module chunks = 0